import { STEPS } from "./steps"

export const createSteps = (STEP_MAP, options = {}) => {
  const { exclude = [] } = options

  return STEPS.filter((s) => !exclude.includes(s.step)).map((s) => ({
    ...s,
    stepId: STEP_MAP[s.step]
  }))
}
